/* eslint-disable react/display-name */
import * as React from 'react';

const StarEmpty = () => (
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Work-in-progress" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g id="Artboard" transform="translate(-44.000000, -26.000000)" fill="#D5D0CC" stroke="#D5D0CC">
        <polygon
          id="Star-Copy-12"
          points="51 36.5 46.8855032 38.663119 47.6713022 34.0815595 44.3426044 30.836881 48.9427516 30.1684405 51 26 53.0572484 30.1684405 57.6573956 30.836881 54.3286978 34.0815595 55.1144968 38.663119"
        />
      </g>
    </g>
  </svg>
);

export default StarEmpty;
